import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  commonItems,
  inboxItems,
  initializeInboxItems,
  KnowledgehubItems,
  MostusedItems,
} from "./Jsonsidebar";
import { jwtDecode } from "jwt-decode";
import { useTheme } from "./Theme/Themecontext";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";

function QuickCard() {
  const { t, i18n } = useTranslation();
  const { styles } = useTheme();
  const { bluetext, blacktext, component } = styles;

  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV
      : process.env.REACT_APP_BASE_URL_PROD;

  const baseUrl1 =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV_1
      : process.env.REACT_APP_BASE_URL_PROD_1;

  const token = localStorage.getItem("Mandoobee-token");
  const userInfo = jwtDecode(token);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [routes, setRoutes] = useState([]);

  const GetRoutes = () => {
    try {
      fetch(`${baseUrl} `, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed t o fetch organization data");
          }
          return response.json();
        })
        .then((data) => {
          if (data.isSuccess) {
            const options = (data.result?.options || []).filter(
              (option) => option.inbox === true
            );
            setRoutes(options);

            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          console.error("Error fetching organization data:", err);
          setError("Error in fetching organization data: " + err);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
      setError("Failed to fetch organization data: " + error);
    }
  };

  useEffect(() => {
    GetRoutes();
  }, []);





  const [showMore, setShowMore] = useState(false);

  const handleSeeMore = () => {
    setShowMore((prevShowMore) => !prevShowMore);
  };

  const [inboxItems, setInboxItems] = useState([]);


  return (
    <section className="block">
      {/* Inbox */}
      <div className="">
        <div
          style={blacktext}
          className={`flex flex-1 justify-between ${
            i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
          }`}
        >
          <p className="text-[14px] font-[600]">{t("inbox")}</p>
          <button
            onClick={handleSeeMore}
            style={bluetext}
            className="  text-[12px] md:text-[14px] "
          >
            {showMore
              ? i18n.language === "ar"
                ? "عرض أقل"
                : "See Less"
              : i18n.language === "ar"
              ? "شاهد المزيد"
              : "See More"}
          </button>
        </div>

        <div
          className={`grid grid-cols-3 mx-2 gap-5 mt-3 ${
            i18n.language === "ar" ? "justify-end" : "justify-start"
          }`}
        >
          {routes.slice(0, showMore ? 5 : 3).map((item, index) => (
            <Link to={`/home${item?.path}`} key={index}>
              <div
                style={component}
                className={`relative flex flex-col justify-center items-center darkshadow  p-2 md:w-[95px] h-[100px] rounded-[10px] ${
                  i18n.language === "ar" ? "text-right" : "text-left"
                }`}
              >
                <div className="">
                  <ReactSVG
                    src={`${baseUrl1}/${item.icon}`}
                    beforeInjection={(svg) => {
                      svg.classList.add("w-6", "h-6");
                   
                      svg.querySelectorAll("*").forEach((element) => {
                     
                        if (
                          element.hasAttribute("fill") &&
                          element.getAttribute("fill") !== "none"
                        ) {
                          element.setAttribute("fill", "#1552b2");
                        } else if (
                          !element.hasAttribute("fill") &&
                          element.tagName !== "svg"
                        ) {
                          // Add fill for elements that don't specify one (except the root svg)
                          element.setAttribute("fill", "none");
                        }

                        // Override any stroke
                        if (element.hasAttribute("stroke")) {
                          element.setAttribute("stroke", "#1552b2");
                        }
                      });
                    }}
                  />
                </div>
                <span style={blacktext} className="text-[12px] text-center">
                  {i18n.language === "ar" ? item.arName : item.name}
                </span>
                {item.count > 0 ? (
                  <div className="absolute  -top-2 -right-1.5 w-[20px] h-[20px] rounded-full bg-[#FAA1AB] text-[#FC1F38]">
                    <p className="text-[10px] text-center mt-0.5">
                      {item.count ?? 0}
                    </p>
                  </div>
                ) : (
                  <>{}</>
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Mostusedservice */}
      {/* <div className="mt-5">
        <div
          style={blacktext}
          className={`flex flex-1 justify-between ${
            i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
          }`}
        >
          <p className=" text-[14px] font-[600]">{t("mostusedservice")} </p>
          <Link to="/home/quickall">
            <p style={bluetext} className=" text-[12px] md:text-[14px]">{t("seemore")}</p>
          </Link>
        </div>
        <div
          className={`grid grid-cols-3 mx-2 gap-5 mt-3 ${
            i18n.language === "ar" ? "justify-end" : "justify-start"
          }`}
        >
          {mostusedItem.slice(0, 3).map((item, index) => (
            <Link to={item.link} key={index}>
              <div
                style={component}
                className={`relative  flex flex-col justify-center items-center darkshadow p-2 md:w-[95px] h-[100px] rounded-[10px] ${
                  i18n.language === "ar" ? "text-right" : "text-left"
                }`}
              >
                <p style={SvgBlue}>{item.icon}</p>
                <span style={blacktext} className="text-[12px] text-center">
                  {t(`mostusedItem.${item.label}`)}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div> */}

      {/* Knowledge Hub */}
      {/* <div className="mt-5">
        <div
          className={`flex flex-1 justify-between ${
            i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
          }`}
        >
          <p style={blacktext} className=" text-[14px] font-[600]">
            {t("knowledgehub")}
          </p>
        </div>
        <div
          className={` grid grid-cols-3 mx-2 gap-5 mt-3 ${
            i18n.language === "ar" ? "justify-end" : "justify-start"
          }`}
        >
          {knowledgeItem.map((item, index) => (
            <Link to={item.link} key={index}>
              <div
                style={component}
                className={`flex  flex-col justify-center items-center darkshadow p-2 md:w-[95px] h-[100px] rounded-[10px] ${
                  i18n.language === "ar" ? "text-right" : "text-left"
                }`}
              >
                <p style={SvgBlue}>{item.icon}</p>
                <span style={blacktext} className="text-[12px] text-center">
                  {t(`knowledgeItem.${item.label}`)}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div> */}

      {/* <div  className={`grid grid-cols-5 gap-4`}>

      {contentItems.slice(1, 5).map((item, index) => (
          <Link to={item.link} key={index} className="m-2">
            <div className="flex flex-col items-center">
              <div style={SvgBlue} className="border rounded-xl p-3.5 shadow-lg">
                {item.icon}
              </div>
              <span className=" text-[9px] text-center py-2">
                {item.label}
              </span>
            </div>
          </Link>
        ))}
          <Link to="/home/quickall">
          <div className="flex flex-col items-center mt-2">
            <div className="border rounded-xl p-[13px] shadow-lg">
              <svg
              style={SvgBlue}
              className=""
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" strokewidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <path
                    d="M5.63574 7.75737L7.04996 6.34315L12.7068 12L7.04998 17.6568L5.63577 16.2426L9.87839 12L5.63574 7.75737Z"
                  ></path>{" "}
                  <path
                    d="M12.7068 6.34315L11.2926 7.75737L15.5352 12L11.2926 16.2426L12.7068 17.6568L18.3637 12L12.7068 6.34315Z"
                  ></path>{" "}
                </g>
              </svg>
            </div>
            <span className=" text-[9px] text-center py-2">
              See More
            </span>
          </div>
        </Link>
      </div> */}
    </section>
  );
}

export default QuickCard;
